import { Component } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';
import { Router } from '@angular/router';

@Component({
  selector: 'pre-build-tier-dialog',
  templateUrl: './PreBuildTier.component.html',
  styleUrls: ['./PreBuildTier.component.scss'],
})
export class PreBuildTierDialogComponent {

  preBuildTierName: string = '';

  constructor(
    private dialogRef: MatDialogRef<PreBuildTierDialogComponent>,
    private router: Router
  ) {}

  save(): void {
    // Save logic here
    // For demonstration, just log the preBuildTierName
    this.dialogRef.close(this.preBuildTierName); // Close the dialog and pass data back
  }

  cancel(): void {
    this.dialogRef.close(); // Close the dialog without passing any data back
  }
}
